import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './components/context/AuthContext'
import PrivateRoute from './components/misc/PrivateRoute'
//import Home from './pages/home/Home'
import Home from './pages/home/HomeComponent'
import Login from './pages/login/Login'
import Splash from './pages/splash/Splash'
import Contact from './pages/contact/contact'
import Experience from './pages/Experience/Experience'
import Education from './pages/Education/EducationComponent'

import Imprint from './pages/Service/imprint'
import Privacy from './pages/Service/privacy'
import Accessibility from './pages/Service/accessibility'
import Sitemap from './pages/Service/sitemap'
import CookiePolicy from './pages/Service/cookie-policy'

import NotFound from './pages/notfound/notfound'

import { chosenTheme } from "./components/styles/themes";
import './App.css';
import { GlobalStyles } from "./global";
import { ThemeProvider } from 'styled-components';
import CookieModal from './components/html/cookiemodal';
import {Helpers} from './components/misc/Helpers';

// <Route path='/' element={<Home />} />
/*
git add . 
git commit -m 'initial commit'
git push origin master 
*/
function App() {
	
	const [showModal, setShowModal] = React.useState(false);
  const handleClose = () => setShowModal(false);
  
  useEffect(() => {
    checkCookie();
    console.log('useEffect called');
  },[]);
  
  async function checkCookie() {
			const cc_cookie = document.cookie.match(Helpers.CC_REGEXP);
			if (!cc_cookie && document.getElementById("cc_hide")==null) {
				setShowModal(true);
			}
	}
	
	async function openModal(event: React.MouseEvent<HTMLAnchorElement>){
		setShowModal(true);
	}

  return (
		<div>
    <AuthProvider>
    	<ThemeProvider theme={chosenTheme}>
      <GlobalStyles theme={chosenTheme}/>
      <Router>
        <Routes>
          <Route path='/' element={<Splash theme={chosenTheme}/>} />
          
          <Route path='/home' element={<Home theme={chosenTheme}/>} />
          <Route path='/splash' element={<Splash theme={chosenTheme}/>} />
          <Route path="/experience" element={<Experience theme={chosenTheme} />} />
          <Route path="/education" element={<Education theme={chosenTheme}/>}/>
          <Route path='/login' element={<Login theme={chosenTheme}/>} />
          <Route path='/contact' element={<Contact theme={chosenTheme}/>} />
          
          <Route path='/Service/imprint' element={<Imprint theme={chosenTheme}/>} />
          <Route path='/Service/privacy' element={<Privacy theme={chosenTheme}/>} />
          <Route path='/Service/accessibility' element={<Accessibility theme={chosenTheme}/>} />
          <Route path='/Service/sitemap' element={<Sitemap theme={chosenTheme}/>} />
          <Route path='/Service/cookie-policy' element={<CookiePolicy theme={chosenTheme} onClickCallParentLevelMethod={openModal}/>} />
          <Route path='*' element={<NotFound theme={chosenTheme}/>}/>
        </Routes>
      </Router>
      </ThemeProvider>
    </AuthProvider>
     <CookieModal open={showModal} onClose={handleClose} theme={chosenTheme}/>
    </div>
  )
}

export default App;
